// Lib
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';

// CREATEALPHBET
const alphabets = [...Array(26)].map((x, i) => String.fromCharCode(i + 65));
class Alphbet extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      fixedPosition: false,
    };
  }
  componentDidMount() {
    document.addEventListener('scroll', this.trackScrolling);
    this.initTop = this.containerRef.current.getBoundingClientRect().top - 110;
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackScrolling);
  }
  trackScrolling = () => {
    if (window.scrollY > this.initTop) {
      this.setState({
        fixedPosition: true,
      });
    } else {
      this.setState({
        fixedPosition: false,
      });
    }
  }
  render() {
    const { fixedPosition } = this.state;
    const { activeAlphabets } = this.props;
    return (
      <div
        ref={this.containerRef}
        className={fixedPosition ? 'alphabetContainer fixed' : 'alphabetContainer'}
      >
        <nav className="alphabet">
          <ul className="alphabet-list" >
            {alphabets.map(alph => {
                const uperAlph = String.fromCharCode(alph.charCodeAt(0));
                const existeAlph = activeAlphabets.includes(uperAlph);
                const classes = existeAlph ?
                    'alphabet-list__item' :
                    'alphabet-list__item disabled';
                return (
                  <li key={alph}>
                    <Link
                      className={classes}
                      to={uperAlph}
                      spy
                      smooth
                      offset={-110}
                      duration={1000}
                    >
                      {alph}
                    </Link>
                  </li>);
              })}
          </ul>
        </nav>
      </div>
    );
  }
}
Alphbet.propTypes = {
  activeAlphabets: PropTypes.array.isRequired,
};

export default Alphbet;



// WEBPACK FOOTER //
// ./src/app/components/pages/lexique/lexiqueResults/parts/Alphabet.js